module.exports = __webpack_public_path__ + "static/media/window-close-solid.b1f2a762.svg";